import script from "./WMA.vue?vue&type=script&lang=js"
export * from "./WMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__